import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { OAuth } from "../models/oauth.model";
import { GraphQLService } from "./graphql.service";
import { HttpClient } from "@angular/common/http";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable()
export class OAuthService extends GraphQLService<OAuth> {

  constructor(
    http: HttpClient,
    snackBar: MatSnackBar,
    private httpClient: HttpClient
  ) {
    super(http, snackBar)
  }

  fetchOAuthRequiredImprints(): Observable<OAuth[]> {
    return this.findAll(`{ oauthRequired { mandator oauthUrl } }`)
  }

  authorize(authorize_url: string): Observable<any> {
    return this.httpClient.get(authorize_url + "&format=json", {
      withCredentials: true,
      responseType: 'json',
      observe: 'response'
    })
  }

  authorizeWithData(postToUrl: string, postData: any): Observable<any> {
    return this.httpClient.post(postToUrl + "?format=json", postData, {
      withCredentials: true,
      responseType: 'json',
      observe: 'response'
    })
  }

  login(imprint: any, login: string, password: string): Observable<any> {
    return this.httpClient.post(imprint.login.post_to, {
      format: 'json',
      login: login,
      password: password
    }, {withCredentials: true, responseType: 'json', observe: 'response'})
  }

  persistCode(imprint: any) {
    return this.httpClient.post(environment.oauth, {
      format: 'json',
      with_original_response: true,
      matchcode: imprint.matchcode,
      code: imprint.code
    }, {withCredentials: true, responseType: 'json', observe: 'response'})
  }

}
